// extracted by mini-css-extract-plugin
export default {"linkName":"Breadcrum_linkName__A6eF1","nonLinkName":"Breadcrum_nonLinkName__AQJQL","breadCrumb":"Breadcrum_breadCrumb__MBD9L","breadContainer":"Breadcrum_breadContainer__h46V7"};